import { render, staticRenderFns } from "./GistSyncModal.vue?vue&type=template&id=4e61dd35&"
import script from "./GistSyncModal.vue?vue&type=script&lang=js&"
export * from "./GistSyncModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GistSyncModal.vue
// module id = 1057
// module chunks = 0